// REFACTOR TYPES

import {RplType} from '@stencil/hotels-types/src/details-types';

const getSlashAndShowPrice = (roomFlavor: RplType) => {
  const payMode = (roomFlavor && roomFlavor.pm) || 1;
  // const payAtHotel = payMode === 2 || payMode === 4 || payMode === 5 || payMode === 3;

  const payAtHotelPaymode = payMode === 2 || payMode === 4;
  const payAtHotelCCRequired = payMode === 3;
  const payAtHotelReserveNowPayLater = payMode === 5;

  const payAtHotel = payAtHotelPaymode || payAtHotelCCRequired || payAtHotelReserveNowPayLater;
  const payAtHotelShowPrice0 = payAtHotelPaymode || payAtHotelReserveNowPayLater;

  // const slashedPrice = payAtHotel ? 0 : roomFlavor.pd?.opr;
  const slashedPrice = roomFlavor && roomFlavor.pd?.opr;

  // const showPrice = payAtHotelShowPrice0 ? 0 : roomFlavor.pd?.spr;
  const showPrice = roomFlavor && roomFlavor.pd?.spr;

  // const payAtPersuasionShowPrice = payAtHotelShowPrice0 ? roomFlavor.pd?.spr : 0;
  const payAtPersuasionShowPrice = roomFlavor && roomFlavor.pd?.spr;

  return {slashedPrice, showPrice, payAtPersuasionShowPrice};
};

export default getSlashAndShowPrice;
